import {ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {filter, map, startWith, takeUntil, tap} from 'rxjs/operators';
import {combineLatest, merge, Observable, Subject} from 'rxjs';
import {ProgressionService} from '@ispm/shared/services/progression.service';
import {
  BP_Status,
  selectExecutionHistoryParsingStatus,
  selectExecutionPath,
  selectExecutionPathAsListItems,
  State
} from '@ispm-client/modules/process-executor/store';
import {select, Store} from '@ngrx/store';
import {ListItem} from '@ispm/widgets/models/list-item';

@Component({
  selector: 'ispm-pathway-steps-list',
  templateUrl: './pathway-steps-list.component.html',
  styleUrls: ['./pathway-steps-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PathwayStepsListComponent implements OnInit, OnDestroy {

  @Input() needKeepPrevious: boolean = false;
  private destroyed$: Subject<any> = new Subject<any>();
  public items$: Observable<ListItem[]>;

  constructor(
    private progressionService: ProgressionService,
    private store$: Store<State>) {
  }

  ngOnInit() {

    const executionPath$ = this.needKeepPrevious ? [] : this.store$.pipe(select(selectExecutionPath));

    const executionHistoryParsingStatus$ = this.store$.pipe(select(selectExecutionHistoryParsingStatus));

    const currentSteps$ = combineLatest([executionPath$, executionHistoryParsingStatus$]).pipe(
      filter(([path, status]) => status === BP_Status.Completed && !!path),
      map(([path, status]) => {
        return (selectExecutionPathAsListItems.projector(path) as ListItem[]).filter(node => !node.enable);
      })
    );

    const history$ = this.progressionService.search('BpmnExecutionHistory').pipe(
      filter(progressions => !!progressions),
      map(progressions => {
        if (progressions.length === 0) {
          return [];
        }
        return progressions[0].data.additionalProperties.history as ListItem[];
      })
    );

    this.items$ = merge(currentSteps$, history$).pipe(
      startWith([] as ListItem[]),
      map(items => items.filter(node => node.enable !== false)),
      tap(items => {
      }),
      takeUntil(this.destroyed$.asObservable())
    );

  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
